export const randomString = (): string =>
  Math.random()
    .toString(36)
    .substring(2, 15) +
  Math.random()
    .toString(36)
    .substring(2, 15);

export const randomKey = (key: string | number): string => `${key}-${randomString()}`;
